// Set sidebar
export const setSidebar = (status = 'show') => {
	return {
		type: 'SET_SIDEBAR',
		options: {
			status,
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/sidebar.js